export enum BannerIcon {
  SUCCESS = 'pi pi-check',
  INFO = 'pi pi-info-circle',
  WARN = 'pi pi-exclamation-triangle',
  ERROR = 'pi pi-times-circle',
  UNDEFINED = 'pi-question-circle'
}
